import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/Button';
import { DateTimeMode } from '@/utils/query-filters';

interface QuickSelectButtonsProps {
    onSelect: (
        days: number,
        hours: number | undefined,
        mode: DateTimeMode,
    ) => void;
}

const QUICK_OPTIONS: readonly {
    days: number;
    hours?: number;
    mode: DateTimeMode;
    key: string;
}[] = [
    {
        days: 0,
        hours: 1,
        mode: DateTimeMode.LAST_HOUR,
        key: 'datePicker.lastHour',
    },
    {
        days: 0,
        hours: 3,
        mode: DateTimeMode.LAST_3_HOURS,
        key: 'datePicker.last3Hours',
    },
    {
        days: 0,
        hours: 6,
        mode: DateTimeMode.LAST_6_HOURS,
        key: 'datePicker.last6Hours',
    },
    {
        days: 0,
        hours: 12,
        mode: DateTimeMode.LAST_12_HOURS,
        key: 'datePicker.last12Hours',
    },
    {
        days: 1,
        hours: undefined,
        mode: DateTimeMode.LAST_24_HOURS,
        key: 'datePicker.last24Hours',
    },
    {
        days: 3,
        hours: undefined,
        mode: DateTimeMode.LAST_3_DAYS,
        key: 'datePicker.last3Days',
    },
];

export function QuickSelectButtons({ onSelect }: QuickSelectButtonsProps) {
    const { t } = useTranslation();

    return (
        <div className="mt-6 flex flex-wrap gap-2">
            {QUICK_OPTIONS.map(({ days, hours, mode, key }) => (
                <Button
                    key={key}
                    variant="tertiary"
                    className="px-[7px] font-normal"
                    onClick={() => onSelect(days, hours, mode)}
                >
                    {t(key)}
                </Button>
            ))}
        </div>
    );
}
